import { Box, Button, Divider, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { FC, useEffect, useMemo } from "react";

import __ from "web/Layout/Translations";

import FieldMUI from "web/Components/Common/Form/Field/fieldMUI";

import {
  getFieldSpecificProps,
  getInitialValues,
} from "web/utils/page/product/subscription/forms/prepareFormData";
import { validateFields } from "web/utils/system/formValidator/validation";

import {
  ISubscriptionFormData,
  ISubscriptionReceiverFormValues,
  SubscriptionActiveFormFieldType,
} from "web/types/Subscription";
import { Nullable } from "web/types/Utils";

interface IReceiverEmailFormProps {
  formData: ISubscriptionFormData;
  receiverEmail: Nullable<string>;
  resend: boolean;
  submitHandler: (values: ISubscriptionReceiverFormValues) => void;
  nextSendAfter?: string;
  closeHandler: () => void;
  isMobile: boolean;
  onDirtyChange: (isDirty: boolean) => void;
}

const ReceiverEmailFormMUI: FC<IReceiverEmailFormProps> = ({
  formData,
  receiverEmail,
  // resend,
  submitHandler,
  nextSendAfter,
  closeHandler,
  isMobile,
  onDirtyChange,
}) => {
  const fields = [
    {
      id: "receiverEmail",
      label: __("E-mail"),
      type: SubscriptionActiveFormFieldType.EMAIL,
      value: "",
      required: true,
    },
    {
      id: "confirmEmail",
      label: __("Powtórz e-mail"),
      type: SubscriptionActiveFormFieldType.CONFIRM_EMAIL,
      value: "",
      required: true,
    },
  ];

  const [initialValues, fieldsToValidate] = useMemo(
    () => getInitialValues(fields, formData),
    [receiverEmail]
  );

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const validate = validateFields(fieldsToValidate);

  const disabledButtonByLimitingEmailSending = !!(
    nextSendAfter && new Date(nextSendAfter).getTime() > new Date().getTime()
  );

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues as ISubscriptionReceiverFormValues}
      onSubmit={submitHandler}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      validate={validate}
    >
      {({ dirty }) => {
        useEffect(() => {
          onDirtyChange(dirty);
        }, [dirty]);

        return (
          <Form noValidate>
            {fields.map((field) => (
              <FieldMUI
                key={field.type}
                label={field.label}
                name={field.id}
                dataT1={field.type}
                required
                disablePaste
                {...getFieldSpecificProps(field.type)}
              />
            ))}
            <Divider sx={{ mt: 2, mb: 1 }} />
            {fields.some((field) => field.required) ? (
              <Box>
                <Typography>*{__("Pola są wymagane")}</Typography>
                <Divider sx={{ pt: 3 }} />
              </Box>
            ) : null}
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: 2,
                flexDirection: isMobile ? "column" : "row",
              }}
            >
              <Button
                variant="outlined"
                color="primary"
                size="large"
                onClick={closeHandler}
                fullWidth={isMobile}
                sx={{ mr: 1, order: isMobile ? 1 : 0, mt: isMobile ? 2 : 0 }}
              >
                {__("Anuluj")}
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                fullWidth={isMobile}
                disabled={disabledButtonByLimitingEmailSending}
                sx={{ order: isMobile ? 0 : 1 }}
              >
                {/* {resend ? __("Zapisz i wyślij") : __("Zapisz i zamknij")} */}
                {__("Zapisz i zamknij")}
              </Button>
            </Box>
          </Form>
        );
      }}
    </Formik>
  );
};

export default ReceiverEmailFormMUI;
